export default "__VITE_ASSET__debc221c__"